<script>
export default {
    name: "COADashboard",

    data() {

        return {
            active: 2,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    methods: {

    },

    components: {
        "coa-transactions-tab": () => import('./tabs/transactions/Index.vue'),
        "general-ledger-tab": () => import('./tabs/general-ledger/Index.vue'),
        "trial-balance-tab": () => import('./tabs/trial-balance/Index.vue'),
        "profit-loss-tab": () => import('./tabs/profit-loss/Index.vue'),
        "balance-sheet-tab": () => import('./tabs/balance-sheet/Index.vue'),
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-medium text-sm">Chart Of Accounts</h5>
        </template>
        <template v-slot:card-body>
            <div class="w-full flex flex-wrap">
                <ul class="w-full flex border-b mb-2">
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 2" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 2 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Transactions</a>
                  </li>
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 3" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 3 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">General Ledger</a>
                  </li>
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 4" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 4 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Trial Balance</a>
                  </li>
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 5" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 5 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Profit & Loss</a>
                  </li>
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 6" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 6 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Balance Sheet</a>
                  </li>
                </ul>
                <coa-transactions-tab v-if="active === 2" />
                <general-ledger-tab v-if="active === 3" />
                <trial-balance-tab v-if="active === 4" />
                <profit-loss-tab v-if="active === 5" />
                <balance-sheet-tab v-if="active === 6" />
            </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
